import React from 'react'
import { element, bool } from 'prop-types'
import { Page } from '@cobalt/cobalt-react-components'
import context from '../../config/context'
import { UserPropType } from '../../types/user'
import {
  TalkdeskFooter,
  TalkdeskNavbar,
  NavbarMenu,
  Wrappers
} from '../../components'

const Base = ({ navbarActionElement, pageHeader, children }) => (
  <Page>
    <TalkdeskNavbar actionElement={navbarActionElement} />
    {pageHeader}
    <Page.Content>{children}</Page.Content>
    <TalkdeskFooter showGoogleFooterLink={context.showGoogleFooterLink} />
  </Page>
)

Base.propTypes = {
  navbarActionElement: element,
  pageHeader: element,
  children: element.isRequired
}

const Centered = ({ children, ...props }) => (
  <Base {...props}>
    <Wrappers.Center>{children}</Wrappers.Center>
  </Base>
)

Centered.propTypes = {
  children: element.isRequired
}

Base.Centered = Centered

export default Base

export const withCenteredBaseWithMenu = (
  WrappedComponent,
  includeUser = false
) =>
  class CenteredBaseWithMenu extends React.PureComponent {
    static propTypes = {
      user: UserPropType.isRequired,
      displayLogoutMenuOnly: bool
    }

    static defaultProps = {
      displayLogoutMenuOnly: false
    }

    render() {
      const { user, displayLogoutMenuOnly, ...props } = this.props
      const wrappedProps = includeUser ? this.props : props
      return (
        <Base.Centered
          navbarActionElement={
            <NavbarMenu
              name={user.name}
              email={user.email}
              displayLogoutMenuOnly={displayLogoutMenuOnly}
            />
          }
        >
          <WrappedComponent {...wrappedProps} />
        </Base.Centered>
      )
    }
  }

export const withBaseWithMenu = (
  WrappedComponent,
  BaseHeader,
  includeUser = false
) =>
  class withBaseWithMenu extends React.PureComponent {
    static propTypes = {
      user: UserPropType.isRequired
    }

    render() {
      const { user, ...props } = this.props
      const wrappedProps = includeUser ? this.props : props

      return (
        <Base
          navbarActionElement={
            <NavbarMenu name={user.name} email={user.email} />
          }
          pageHeader={BaseHeader ? <BaseHeader /> : <React.Fragment />}
        >
          <WrappedComponent {...wrappedProps} />
        </Base>
      )
    }
  }
